import { findDOMNode } from 'libs/react';
/**
 * @method getNode
 * @since 1.0.0
 */
export function getDOMNode(ref) {
    // eslint-disable-next-line react/no-find-dom-node
    return (ref && findDOMNode(ref)) || null;
}
